export const MEDIA_PASS_STATUS = 'status';
export const PARAMETER = 'stream-parameter';
export const VALUE = 'stream-parameter-value';
export const TYPE = 'stream-type';
export const ERROR_MESSAGE = 'message';
export const VAST_PASS = 'valid';
export const AD_ID = 'ad-id';
export const VAST = 'parsable';
export const AD = 'ad-tag-valid';
export const INLINE = 'inline-tag-valid';
export const IMPRESSION = 'impression-url-valid';
export const CREATIVE = 'creative-tag-valid';
export const LINEAR = 'linear-creative-tag-valid';
export const MEDIA_FILE = 'media-file-tag-valid';
export const PRIMARY = 'primary';
export const INGESTION_NOTE = 'ingestion-note';
export const MEDIA_FILE_URL = 'media-file-url';
export const VIDEO_BIT_RATE = 'video-bit-rate';
export const VIDEO_RESOLUTION = 'video-resolution';
export const NO_VALID_MEDIA_FILE = 'No Valid Media File';
export const LOADING = 'loading';
export const COMPLETE = 'complete';
export const FAILURE = 'failure';
export const COUNTRY_CODES = [
  {
    value: 'CA',
    label: 'Canada',
  },
  {
    value: 'DK',
    label: 'Denmark',
  },
  {
    value: 'FR',
    label: 'France',
  },
  {
    value: 'DE',
    label: 'Germany',
  },
  {
    value: 'IT',
    label: 'Italy',
  },
  {
    value: 'NO',
    label: 'Norway',
  },
  {
    value: 'ES',
    label: 'Spain',
  },
  {
    value: 'SE',
    label: 'Sweden',
  },
  {
    value: 'CH',
    label: 'Switzerland',
  },
  {
    value: 'GB',
    label: 'United Kingdom',
  },
];
